import { Menu, PanelLeftClose, PanelLeftOpen } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import { findNavigationItem } from '../../config/navigation';
import Breadcrumbs from './Breadcrumbs';
import NotificationMenu from './NotificationMenu';
import UserMenu from './UserMenu';

function AdminHeader({ sidebarCollapsed, onToggleSidebar, onOpenMobileMenu }) {
  const { pathname } = useLocation();
  const currentItem = findNavigationItem(pathname);

  return (
    <header className="sticky top-0 z-30 border-b bg-white/95 backdrop-blur">
      <div className="flex h-16 items-center justify-between gap-4 px-4 sm:px-6 lg:px-8">
        <div className="flex min-w-0 items-center gap-3">
          <button type="button" onClick={onOpenMobileMenu} className="grid size-10 place-items-center rounded-control text-content-muted hover:bg-slate-100 lg:hidden" aria-label="Abrir menú">
            <Menu className="size-5" />
          </button>
          <button type="button" onClick={onToggleSidebar} className="hidden size-10 place-items-center rounded-control text-content-muted hover:bg-slate-100 lg:grid" aria-label={sidebarCollapsed ? 'Expandir sidebar' : 'Plegar sidebar'}>
            {sidebarCollapsed ? <PanelLeftOpen className="size-5" /> : <PanelLeftClose className="size-5" />}
          </button>
          <div className="min-w-0">
            <h1 className="truncate text-base font-semibold text-content-primary sm:text-lg">{currentItem?.name || 'Administración'}</h1>
            <div className="hidden sm:block"><Breadcrumbs /></div>
          </div>
        </div>
        <div className="flex items-center gap-1 sm:gap-2">
          <NotificationMenu />
          <span className="mx-1 hidden h-7 w-px bg-border sm:block" />
          <UserMenu />
        </div>
      </div>
    </header>
  );
}

export default AdminHeader;
